export default __webpack_public_path__ + "static/media/group-16.7736afbb.svg";